<template>
    <div class="lottery-group-box">
        <div class="lottery-group-box__header">
            <h4
                id="3d-group-modal-title"
                class="lottery-group-box__title"
            >
                {{
                    $store.state.language === "en"
                        ? "Three-D Group"
                        : "အုပ်စုလိုက်ထိုးမည်"
                }}
            </h4>
            <p class="lottery-group-box__subtitle">
                {{
                    $store.state.language === "en"
                        ? "Choose a group pattern to bet quickly."
                        : "အမြန်ထိုးရန် အုပ်စုပုံစံတစ်ခု ရွေးပါ။"
                }}
            </p>
        </div>

        <div class="lottery-group-box__body">
            <div class="lottery-group-box__grid">
                <a
                    href="#"
                    class="lottery-group-box__chip"
                    data-toggle="modal"
                    data-target="#tri"
                    >{{
                        $store.state.language === "en"
                            ? "Tri"
                            : "သုံးလုံးထွိုင်"
                    }}</a
                >
                <a
                    href="#"
                    class="lottery-group-box__chip"
                    data-toggle="modal"
                    data-target="#tri_round"
                    >{{
                        $store.state.language === "en"
                            ? "Tri Round"
                            : "သုံးလုံး ပတ်လည်"
                    }}</a
                >
                <a
                    href="#"
                    class="lottery-group-box__chip"
                    data-toggle="modal"
                    data-target="#rest_tri_round"
                    >{{
                        $store.state.language === "en"
                            ? "Rest Tri Round"
                            : "သုံးလုံး ကျန်ပတ်လည်"
                    }}</a
                >
                <a
                    href="#"
                    class="lottery-group-box__chip"
                    data-toggle="modal"
                    data-target="#brake"
                    >{{
                        $store.state.language === "en"
                            ? "Brake"
                            : "သုံးလုံး ဘရိတ်"
                    }}</a
                >
                <a
                    href="#"
                    class="lottery-group-box__chip"
                    data-toggle="modal"
                    data-target="#front_serie"
                    >{{
                        $store.state.language === "en"
                            ? "Front Serie"
                            : "ရှေ့စီးရီး"
                    }}</a
                >
                <a
                    href="#"
                    class="lottery-group-box__chip"
                    data-toggle="modal"
                    data-target="#middle_serie"
                    >{{
                        $store.state.language === "en"
                            ? "Middle Serie"
                            : "အလယ်စီးရီး"
                    }}</a
                >
                <a
                    href="#"
                    class="lottery-group-box__chip"
                    data-toggle="modal"
                    data-target="#back_serie"
                    >{{
                        $store.state.language === "en"
                            ? "Back Serie"
                            : "နောက်စီးရီး"
                    }}</a
                >
            </div>
        </div>

        <!-- === for tri === -->
        <InputSelectDrawModalVue
            id_type="tri"
            modalType="one"
            :selected_data="selected_data"
            @type="getType"
        />
        <!-- === for tri_round === -->
        <InputSelectDrawModalVue
            id_type="tri_round"
            modalType="round"
            :selected_data="selected_data"
            @type="getType"
        />
        <!-- === for rest_tri_round === -->
        <InputSelectDrawModalVue
            id_type="rest_tri_round"
            modalType="round"
            :selected_data="selected_data"
            @type="getType"
        />
        <!-- === for rest_tri_round === -->
        <InputSelectDrawModalVue
            id_type="front_serie"
            :selected_data="selected_data"
            @type="getType"
        />
        <!-- === for rest_tri_round === -->
        <InputSelectDrawModalVue
            id_type="middle_serie"
            :selected_data="selected_data"
            @type="getType"
        />
        <!-- === for rest_tri_round === -->
        <InputSelectDrawModalVue
            id_type="back_serie"
            :selected_data="selected_data"
            @type="getType"
        />
        <!-- === for brake === -->
        <InputSelectDrawModalVue
            id_type="brake"
            :selected_data="selected_data"
            @type="getType"
        />
    </div>
</template>
<script>
import InputSelectDrawModalVue from './InputSelectDrawModal.vue';

export default {
  components: { InputSelectDrawModalVue },
  data() {
    return {
      selected_data: {},
      numbers: [],
      allNumbers: [],
    };
  },
  methods: {
    getType(value) {
      this.selectNumbers(value.id_type);
      this.setAmount(value.amount);
      this.$emit('numbers', this.numbers);
    },
    setAmount(amount) {
      const currentHour = new Date().getHours();
      const draw = currentHour < 12 ? '12:00' : '4:30';
      for (let i = 0; i < this.numbers.length; i += 1) {
        this.numbers[i].solo_amount = amount;
        this.numbers[i].draw = draw;
      }
    },
    selectNumbers(type) {
      switch (type) {
        case 'tri':
          this.numbers = this.allNumbers.filter((el) => {
            const threedArray = el.number
              .toString(10)
              .split('')
              .map((t) => t);
            const firstNum = threedArray[0];
            const secondNum = threedArray[1];
            const thirdNum = threedArray[2];
            return firstNum === secondNum && secondNum === thirdNum;
          });
          break;
        case 'tri_round':
          this.numbers = this.allNumbers.filter((el) => {
            const threedArray = this.selected_data.number_select
              .toString(10)
              .split('')
              .map((t) => t);
            const firstNum = threedArray[0];
            const secondNum = threedArray[1];
            const thirdNum = threedArray[2];
            /* eslint-disable */
            return (
              el.number == firstNum + thirdNum + secondNum
            || el.number == secondNum + firstNum + thirdNum
            || el.number == firstNum + secondNum + thirdNum
            || el.number == secondNum + thirdNum + firstNum
            || el.number == thirdNum + firstNum + secondNum
            || el.number == thirdNum + secondNum + firstNum
            );
          });
          break;
        case 'rest_tri_round':
          this.numbers = this.allNumbers.filter((el) => {
            const threedArray = this.selected_data.number_select
              .toString(10)
              .split('')
              .map((t) => t);
            const firstNum = threedArray[0];
            const secondNum = threedArray[1];
            const thirdNum = threedArray[2];
            /* eslint-disable */
            return (
              (el.number == firstNum + thirdNum + secondNum
            || el.number == secondNum + firstNum + thirdNum
            || el.number == firstNum + secondNum + thirdNum
            || el.number == secondNum + thirdNum + firstNum
            || el.number == thirdNum + firstNum + secondNum
            || el.number == thirdNum + secondNum + firstNum) && (this.selected_data.number_select.toString() !== el.number.toString())
            );
          });
          break;
        case 'brake':
          this.numbers = this.allNumbers.filter((el) => {
            const threedArray = el.number
              .toString(10)
              .split('')
              .map((t) => t);
            let total = 0;
            for (let i = 0; i < threedArray.length; i += 1) {
              total += parseInt(threedArray[i], 10);
            }
            const totalArray = total.toString();
            const lastChar = totalArray.slice(-1);

            return (
              lastChar
                            === this.selected_data.number_select.toString()
            );
          });
          break;
        case 'front_serie':
          this.numbers = this.allNumbers.filter((el) => {
            const threedArray = el.number
              .toString(10)
              .split('')
              .map((t) => t);
            const first = threedArray[0];
            const second = threedArray[1];
            const third = threedArray[2];
            if (
              this.selected_data.number_select.toString()
                            === first.toString()
            ) {
              return (
                (second === '1' && third === '2')
                                || (second === '1' && third === '2')
                                || (second === '3' && third === '4')
                                || (second === '5' && third === '6')
                                || (second === '7' && third === '8')
                                || (second === '9' && third === '0')
                                || (second === '0' && third === '9')
                                || (second === '8' && third === '7')
                                || (second === '6' && third === '5')
                                || (second === '4' && third === '3')
                                || (second === '2' && third === '1')
              );
            }
            return false;
          });

          break;
        case 'middle_serie':
          this.numbers = this.allNumbers.filter((el) => {
            const threedArray = el.number
              .toString(10)
              .split('')
              .map((t) => t);
            const first = threedArray[0];
            const second = threedArray[1];
            const third = threedArray[2];
            if (
              this.selected_data.number_select.toString()
                            === second.toString()
            ) {
              return (
                (first === '1' && third === '2')
                                || (first === '1' && third === '2')
                                || (first === '3' && third === '4')
                                || (first === '5' && third === '6')
                                || (first === '7' && third === '8')
                                || (first === '9' && third === '0')
                                || (first === '0' && third === '9')
                                || (first === '8' && third === '7')
                                || (first === '6' && third === '5')
                                || (first === '4' && third === '3')
                                || (first === '2' && third === '1')
              );
            }
            return false;
          });

          break;
        case 'back_serie':
          this.numbers = this.allNumbers.filter((el) => {
            const threedArray = el.number
              .toString(10)
              .split('')
              .map((t) => t);
            const first = threedArray[0];
            const second = threedArray[1];
            const third = threedArray[2];
            if (
              this.selected_data.number_select.toString()
                            === third.toString()
            ) {
              return (
                (first === '1' && second === '2')
                                || (first === '1' && second === '2')
                                || (first === '3' && second === '4')
                                || (first === '5' && second === '6')
                                || (first === '7' && second === '8')
                                || (first === '9' && second === '0')
                                || (first === '0' && second === '9')
                                || (first === '8' && second === '7')
                                || (first === '6' && second === '5')
                                || (first === '4' && second === '3')
                                || (first === '2' && second === '1')
              );
            }
            return false;
          });

          break;
        default:
          break;
      }
    },
    async fetchNumbers() {
      try {
        const res = await axios.post('/threed_numbers', {
          limit: 'all',
        });
        this.numbers = res.data.data;
        this.allNumbers = res.data.data;
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.fetchNumbers();
  },
};
</script>
<style scoped>
.lottery-group-box {
  background: #FFFFFF;
}

.lottery-group-box__header {
  background: #0D3B1A;
  padding: 1.1rem 1.25rem 1rem;
  text-align: center;
}

.lottery-group-box__title {
  margin: 0;
  color: #FFFFFF !important;
  font-size: 1.05rem;
  font-weight: 700;
  line-height: 1.35;
}

.lottery-group-box__subtitle {
  margin: 0.45rem 0 0;
  color: #FFFFFF !important;
  font-size: 0.82rem;
  font-weight: 500;
  line-height: 1.4;
}

.lottery-group-box__body {
  padding: 1rem;
  background: #FFFFFF;
}

.lottery-group-box__grid {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.lottery-group-box__chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 38px;
  padding: 0.45rem 0.8rem;
  border-radius: 10px;
  border: 1.5px solid rgba(13, 59, 26, 0.22);
  background: #F5F7F5;
  color: #0D3B1A !important;
  font-size: 0.85rem;
  font-weight: 700;
  text-align: center;
  text-decoration: none !important;
  line-height: 1.25;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

.lottery-group-box__chip:hover {
  background: #0D3B1A;
  border-color: #0D3B1A;
  color: #FFFFFF !important;
}
</style>
